<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="getColunas()"
			:items="itensProcessos"
			item-key="id"
			dense
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			no-data-text="Nenhum processo por aqui"
			class="arp-listview"
		>
			<template #[`item.data-table-select`]="{ isSelected, select }">
				<v-simple-checkbox
					id="caixaDeSelecao"
					class="row-checkbox"
					color="primary"
					:value="isSelected"
					@input="select($event)"
					@click.stop
				></v-simple-checkbox>
			</template>
			<template #item.descricaoFornecedor="{ item }">
				<texto-tooltip
					:texto="montarDescricaoFornecedor(item.documento, item.razaoSocial)"
					:tamanho-maximo="textoTamanhoMaximo"
				></texto-tooltip>
			</template>
			<template #item.tipoAta="{ item }">
				<span> {{ item.loteNumero }} </span>
				<span v-show="item.quantidadeLotes > maximoLotePorColuna"> e </span>
				<a
					class="font-weight-bold"
					v-show="item.quantidadeLotes > maximoLotePorColuna"
					@click="abrirModalComItemTipoSelecionado(montarFiltroModalLote(item))"
					>+{{ item.quantidadeLotes - 1 }}</a
				>
			</template>
			<template #item.acoes="{ item }">
				<v-btn-toggle
					v-ripple="false"
					variant="text"
					borderless
					primary
					v-model="item.selecionado"
					@change="adicionar(item)"
				>
					<v-tooltip top color="black">
						<template #activator="{ on }">
							<v-btn
								icon
								fab
								v-ripple="false"
								v-on="on"
								block
								:value="false"
								primary
								v-if="isSelecionado(item)"
							>
								<v-icon color="error">mdi-minus-circle</v-icon>
							</v-btn>
							<v-btn icon fab v-ripple="false" v-on="on" block :value="true" primary v-else>
								<v-icon color="primary">mdi-plus-circle</v-icon>
							</v-btn>
						</template>
						<span>{{ getTextoAdicionarRemover(item) }}</span>
					</v-tooltip>
				</v-btn-toggle>
			</template>
		</v-data-table>

		<paginacao-tabela
			v-if="totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
			:show-rows-per-page="false"
		></paginacao-tabela>

		<modal
			:max-width="modalOptions.largura"
			:max-height="modalOptions.altura"
			:exibir="modalOptions.exibir"
			:titulo="modalOptions.tituloModal"
			@close="fecharModal"
			:custom-actions="true"
		>
			<template #body>
				<v-row class="pt-5">
					<div v-for="(lote, index) in lotesDaModal(modalOptions.datasource)" :key="index" class="ma-2">
						<v-tooltip top>
							<template #activator="{ on }">
								<v-chip color="grey lighten-3" label v-on="on">{{ lote.tituloFormatado }}</v-chip>
							</template>
							<span>{{ lote.tituloFormatado }}</span>
						</v-tooltip>
					</div>
				</v-row>
			</template>
		</modal>
	</div>
</template>

<script>
import { actionTypes, getterTypes } from '@/core/constants'
import mutationTypes from '@/core/constants/mutation-types'
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import { mapGetters, mapState } from 'vuex'

export default {
	name: 'modal-primeira-etapa-listagem',
	mixins: [tabelaMixin],

	props: {
		itensProcessos: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			paginacaoInterna: this.paginacao,
			textoTamanhoMaximo: 80,
			maximoLotePorColuna: 1,
			modalOptions: this.initializeModalOptions(),
			filtroMascaraCNPJ: this.$options.filters.azCpfCnpj,
			isIntegracaoWeblicAtivo: this.$store.state.parametrosSistema.isIntegracaoWeblicAtivo,
		}
	},
	computed: {
		...mapGetters({
			isSelecionado: getterTypes.ITEM_ATA.IS_SELECIONADO,
		}),
		...mapState({
			filtro: (state) => state.itemProcesso.filtro,
		}),
		deveExibirCampoNumeroIntegracaoAtiva() {
			return this.isIntegracaoWeblicAtivo
		},
	},
	methods: {
		getTextoAdicionarRemover(item) {
			if (item.selecionado) return 'Remover da seleção'
			return 'Adicionar à seleção'
		},
		lotesDaModal: (lotes) => {
			return lotes.filter((item) => {
				return item.isVisible
			})
		},
		initializeModalOptions() {
			return {
				largura: '30%',
				altura: '50%',
				tituloModal: 'Tipos',
				datasource: [],
				exibir: false,
			}
		},
		async abrirModalComItemTipoSelecionado(filtroModalLoteSelecionado) {
			this.modalOptions.exibir = true
			await this.buscarLotesPorProcessoSelecionado(filtroModalLoteSelecionado)
		},
		async buscarLotesPorProcessoSelecionado(filtroModalLoteSelecionado) {
			this.modalOptions.datasource = await this.carregarLotesPorFiltro(filtroModalLoteSelecionado)
		},
		async carregarLotesPorFiltro(filtro) {
			this.$store.commit(mutationTypes.TIPO.POR_NUMERO_E_ITEM_PROCESSO.SET_FILTRO, filtro)

			const { itens } = await this.$store.dispatch(
				actionTypes.TIPO.POR_NUMERO_E_ITEM_PROCESSO.BUSCAR_TIPOS_POR_NUMERO_E_PROCESSO,
			)

			return itens.map((item) => {
				item.isVisible = item.tituloFormatado !== filtro.loteNumero
				return item
			})
		},
		montarFiltroModalLote(item) {
			return {
				idsTipos: this.filtro.idsTipos,
				loteNumero: item.loteNumero,
				idProcesso: item.idProcesso,
				idFornecedor: item.idFornecedor,
				numeroEdital: item.numeroEdital,
				isUsadoEmAta: false,
			}
		},
		montarDescricaoFornecedor(cnpj, descricaoFornecedor) {
			return `${this.filtroMascaraCNPJ(cnpj)} - ${descricaoFornecedor}`
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
		fecharModal() {
			this.modalOptions.exibir = false
			this.$emit('fechar-modal')
		},
		async adicionar(item) {
			let lotes = await this.carregarLotesPorFiltro(this.montarFiltroModalLote(item))

			item.idLotes = lotes.map((lote) => lote.id)
			item.idItensNaoAdicionados = []

			this.$store.commit(mutationTypes.ITEM_ATA.GERAR_ATA_COM_PROCESSO.SET_ITENS_SELECIONADOS, item)
		},
		getColunas() {
			const primeiraColunaTitulo = this.deveExibirCampoNumeroIntegracaoAtiva ? 'Nº Edital' : 'Nº Processo'

			return [
				new TabelaColunaUtils(primeiraColunaTitulo, 'processoNumero', '15%'),
				new TabelaColunaUtils('Fornecedor', 'descricaoFornecedor', '65%'),
				new TabelaColunaUtils('Grupo', 'tipoAta', '15%'),
				new TabelaColunaUtils('', 'acoes', '5%'),
			]
		},
	},
}
</script>
<style lang="stylus" scoped>
.arp-listview
	margin-top 1%;

.v-btn:before {
	opacity: 0 !important;
}

.v-ripple__container {
	opacity: 0 !important;
}

.v-btn-toggle:hover {
	background-color: transparent !important;
}

.v-btn-toggle {
	background-color: transparent !important;
}
</style>
